import React from "react";
import { connect } from "react-redux";

import { getWidgetSpecificProps } from "@utils/index";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { Box } from "@acko-tech/building-blocks.ui.common";
import { convertToLakh } from "@utils/inrFormatter";
import Hyperlink from "@components/common/hyperlink";
import { IDVSectionWrapper } from "./styles";

const mapStateToProps = function (state: any, ownProps: any) {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id,
  );
};

const IdvSection = (props) => {
  const { idvData, styles, displayText, actions, is_visible, mStyles } = props;
  const { on_click } = actions || {};
  return is_visible ? (
    <IDVSectionWrapper styles={styles} mStyles={mStyles}>
      <Text
        styles={{
          fontSize: "14px",
          fontWeight: 400,
          lineHeight: "20px",
          display: "inline",
          color: "#040222",
        }}
      >
        {displayText}{" "}
        <span style={{ fontWeight: 600 }}>
          ₹{convertToLakh(idvData?.selected)} lakh
        </span>
      </Text>
      <Hyperlink
        text={"Edit"}
        styles={{
          display: "inline",
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: "20px",
          marginLeft: "0.5rem",
        }}
        type={"PRIMARY"}
        clickHandler={() => {
          if (on_click?.[0] && typeof on_click[0].funCall === "function") {
            on_click?.forEach((eachFunc: any) => {
              eachFunc.funCall(eachFunc.args);
            });
          }
        }}
      />
    </IDVSectionWrapper>
  ) : null;
};

export default connect(mapStateToProps)(IdvSection);
